import * as bre from '../services/bre';

export default {
  namespace: 'bre',

  state: {
    allFieldPackageList: null,
    fieldPackageDetailList: null,
    allConstructList: null,
    allPackages: null,
    constructDetailList: null,
  },

  effects: {
    *getAllFieldPackage({ payload: {}, callback }, { call, put }) {
      const { data: response } = yield call(bre.getAllFieldPackage);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          allFieldPackageList: response,
        },
      });
    },
    *getFieldPackageDetails({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(bre.getFieldPackageDetails, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          fieldPackageDetailList: response,
        },
      });
    },
    //清空配置列表
    *resetFieldPackageDetails({}, { put }) {
      yield put({
        type: 'save',
        payload: {
          fieldPackageDetailList: null,
        },
      });
    },
    //出参配置
    *getConstruct({}, { call, put }) {
      const { data: response } = yield call(bre.getConstruct);
      yield put({
        type: 'save',
        payload: {
          allConstructList: response,
        },
      });
    },
    //出参配置详情
    *getConstructDetails({ payload: { values } }, { call, put }) {
      const { data: response } = yield call(bre.getConstructDetails, values);
      let arr = response.map((item) => ({ name: item }));
      yield put({
        type: 'save',
        payload: {
          constructDetailList: arr,
        },
      });
    },

    //获取所有字段包名
    *getAllPackages({ payload: {}, callback }, { call, put }) {
      const { data: response } = yield call(bre.getAllPackages);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          allPackages: response,
        },
      });
    },

    //清空出参配置列表
    *resetConstructDetails({}, { put }) {
      yield put({
        type: 'save',
        payload: {
          constructDetailList: null,
        },
      });
    },
  },
  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
